import React, { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';

export default function Header() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const handleLogout = () => { logout(); navigate('/login'); setOpen(false); };

  // Close on outside click / touch
  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('touchstart', close);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('touchstart', close);
    };
  }, [open]);

  const go = (path) => { navigate(path); setOpen(false); };

  return (
    <header className="header">
      <div className="header-inner">

        {/* Profile icon — leftmost */}
        <div className="header-profile">
          <span className="header-profile-icon">👤</span>
          {user && <span className="header-profile-name">{user.username}</span>}
        </div>

        {/* Hamburger */}
        <div className="hamburger-wrap" ref={wrapRef}>
          <button className="hamburger-btn" onClick={() => setOpen(o => !o)} aria-label="Menu">
            <span className="hamburger-icon">
              <span /><span /><span />
            </span>
          </button>

          {open && (
            <div className="hamburger-menu">
              <button className="hamburger-item" onClick={() => go('/')}>🏠 Home</button>
              <button className="hamburger-item" onClick={() => go('/stadiums')}>🏟️ Stadiums</button>
              <button className="hamburger-item" onClick={() => go('/fun-facts')}>🌍 Fun Facts</button>
              <button className="hamburger-item" onClick={() => go('/daily-sim')}>🎲 Daily Sim</button>
              {user?.is_admin && (
                <button className="hamburger-item" onClick={() => go('/admin')}>⚙️ Admin</button>
              )}
              <div className="hamburger-divider" />
              {user ? (
                <button className="hamburger-item hamburger-item-logout" onClick={handleLogout}>Log out</button>
              ) : (
                <>
                  <button className="hamburger-item" onClick={() => go('/login')}>Log in</button>
                  <button className="hamburger-item hamburger-item-join" onClick={() => go('/register')}>Join free</button>
                </>
              )}
            </div>
          )}
        </div>

      </div>
    </header>
  );
}
